import { FORMAT_STATION_SLOT, STATION_SLOT, STATION_TYPE } from '~common';
import { StationInfoDisplay } from '~types';

export function getStationInfoDisplay(
  typeBox?: STATION_TYPE | FORMAT_STATION_SLOT,
  slotBox?: STATION_SLOT,
) {
  const STATION_INFO_MAP: Record<
    STATION_SLOT | STATION_TYPE | FORMAT_STATION_SLOT,
    StationInfoDisplay
  > = {
    [STATION_SLOT.SLOT_5]: {
      imageUrl: '/images/station5.svg',
      title: 'F5',
      type: '(5-Unit)',
    },
    [STATION_SLOT.SLOT_10]: {
      imageUrl: '/images/station10.svg',
      title: 'F10',
      type: '(10-Unit)',
    },
    [STATION_SLOT.SLOT_15]: {
      imageUrl: '/images/station15.svg',
      title: 'F15',
      type: '(15-Unit)',
    },
    [STATION_SLOT.SLOT_25]: {
      imageUrl: '/images/station25.svg',
      title: 'F25',
      type: '(25-Unit)',
    },
    [STATION_SLOT.SLOT_45]: {
      imageUrl: '/images/station45.svg',
      title: 'F45',
      type: '(45-Unit)',
    },
    [STATION_SLOT.SLOT_100]: {
      imageUrl: '/images/station100.svg',
      title: 'F100',
      type: '(100-Unit)',
    },
    [STATION_TYPE.SLOT_5]: {
      imageUrl: '/images/station5.svg',
      title: 'F5',
      type: '(5-Unit)',
    },
    [STATION_TYPE.SLOT_10]: {
      imageUrl: '/images/station10.svg',
      title: 'F10',
      type: '(10-Unit)',
    },
    [STATION_TYPE.SLOT_15]: {
      imageUrl: '/images/station15.svg',
      title: 'F15',
      type: '(15-Unit)',
    },
    [STATION_TYPE.SLOT_25]: {
      imageUrl: '/images/station25.svg',
      title: 'F25',
      type: '(25-Unit)',
    },
    [STATION_TYPE.SLOT_45]: {
      imageUrl: '/images/station45.svg',
      title: 'F45',
      type: '(45-Unit)',
    },
    [STATION_TYPE.SLOT_100]: {
      imageUrl: '/images/station100.svg',
      title: 'F100',
      type: '(100-Unit)',
    },
    [STATION_TYPE.BOX_5]: {
      imageUrl: '/images/station5.svg',
      title: 'F5',
      type: '(5-Unit)',
    },
    [STATION_TYPE.BOX_10]: {
      imageUrl: '/images/station10.svg',
      title: 'F10',
      type: '(10-Unit)',
    },
    [STATION_TYPE.BOX_15]: {
      imageUrl: '/images/station15.svg',
      title: 'F15',
      type: '(15-Unit)',
    },
    [STATION_TYPE.BOX_25]: {
      imageUrl: '/images/station25.svg',
      title: 'F25',
      type: '(25-Unit)',
    },
    [STATION_TYPE.BOX_45]: {
      imageUrl: '/images/station45.svg',
      title: 'F45',
      type: '(45-Unit)',
    },
    [STATION_TYPE.BOX_100]: {
      imageUrl: '/images/station100.svg',
      title: 'F100',
      type: '(100-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_5]: {
      imageUrl: '/images/station5.svg',
      title: 'F5',
      type: '(5-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_10]: {
      imageUrl: '/images/station10.svg',
      title: 'F10',
      type: '(10-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_15]: {
      imageUrl: '/images/station15.svg',
      title: 'F15',
      type: '(15-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_25]: {
      imageUrl: '/images/station25.svg',
      title: 'F25',
      type: '(25-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_45]: {
      imageUrl: '/images/station45.svg',
      title: 'F45',
      type: '(45-Unit)',
    },
    [FORMAT_STATION_SLOT.SLOT_100]: {
      imageUrl: '/images/station100.svg',
      title: 'F100',
      type: '(100-Unit)',
    },
  };

  return (
    (typeBox && STATION_INFO_MAP[typeBox]) ||
    (slotBox && STATION_INFO_MAP[slotBox]) ||
    STATION_INFO_MAP[STATION_TYPE.BOX_5]
  );
}
